export const MAIN_NAV = ["inventory", "sourcing", "sell", "export", "company", "contact"];
export const LEGAL_NAV = ["privacy", "legal"];
export const SHELL_PAGES = []; // all Stage 1 shell pages are real pages since Stage 4A
